// extracted by mini-css-extract-plugin
export var active = "_l5-2";
export var recordingDot = "_l5-1";
export var recordingIndicator = "_l5-0";